import React, { useContext } from 'react'
import formatDate from 'date-fns/format'
import { OccasionQuickLinkProps } from '@interflora/ui-components/build/common/props'
import AvailabilityCheckerContext from '../../context/AvailabilityCheckerContext'
import AvailabilityChecker from '../AvailabilityChecker/AvailabilityChecker'
import CategoryAvailabilityConfirmationUI from '@interflora/ui-components/build/components/CategoryAvailabilityConfirmation/CategoryAvailabilityConfirmation'

interface Props {
  /** Occasion quick links for availability checker (IFCT-8570) */
  occasionQuickLinks?: OccasionQuickLinkProps[]
}

/**
 * IFCT-8570: Renders the AvailabilityChecker before submission, then swaps it for
 * the CategoryAvailabilityConfirmation summary once the customer has submitted their
 * date and address. Relies on AvailabilityCheckerContext (provided in Page.tsx) to
 * share state between this header section and the ProductListing below.
 */
const CategoryAvailabilitySection = ({ occasionQuickLinks }: Props) => {
  const availabilityChecker = useContext(AvailabilityCheckerContext)
  const formValues = availabilityChecker?.formValues

  if (formValues) {
    const formattedDate = formValues.date ? formatDate(formValues.date, 'do MMMM') : ''
    return (
      <CategoryAvailabilityConfirmationUI
        formattedDate={formattedDate}
        postalCode={formValues.postalCode}
        onStartAgain={() => availabilityChecker.clearFormValues()}
      />
    )
  }

  return <AvailabilityChecker hideOccasion skipRedirect occasionQuickLinks={occasionQuickLinks} />
}

export default CategoryAvailabilitySection
